<template>
  <div>

<b-container>
  <select id="officeT" class="dropDown60px" @change="goFunction()" style="z-index:1;">
    <option value="whoweare">আমাৰ পৰিচয়</option>
    <option value="regoffice">পঞ্জীভুক্ত কাৰ্যালয়</option>
    <option value="profile">কোম্পানীৰ সংক্ষিপ্ত</option>
    <option value="glance">চকুৰ পচাৰতে এপিদিচিএল</option>
    <option value="Mandate">কোম্পানীৰ আদেশ</option>
    <option value="vision">আমাৰ ভৱিষ্যদৰ্শন</option>
    <option value="mission">আমাৰ লক্ষ্য</option>
    <option value="minister">মন্ত্ৰী</option>
    <option value="bod">সঞ্চালক মণ্ডলী</option>
    <!-- <option value="chairmsg">Chairman's Message</option>
    <option value="mdmsg">MD's Message</option> -->
    <!-- <option value="jobchart">Job Chart and Responsibilities of<br> Key Officials</option> -->
    <option value="adminh">প্ৰশাসনীয় বৰ্গীকৰণ</option>
    <option value="gmap">ভৌগোলিক মানচিত্ৰ</option>
    <option value="pmap">শক্তি মানচিত্ৰ</option>
    <option value="iso">আই এচ অ’ প্ৰমাণ পত্ৰ</option>
    <option value="qp">গুণাগুণ নীতি</option>
  </select>
</b-container>

</div>
</template>
<script>
export default
 {

  methods: {
    goFunction()
    {
      var ofc=document.getElementById('officeT').value;
    //  alert("Office::"+ofc);
    if(ofc == "iso"){
      window.location.href= "https://www.apdcl.org/irj/go/km/docs/internet/ASSAM/webpage/PDF/ISO_Certificate.pdf"
    }
    else if( ofc == "qp"){
      window.location.href= "https://www.apdcl.org/irj/go/km/docs/internet/ASSAM/webpage/PDF/Quality_Policy.pdf"
    }
      this.goto(ofc);
    },

  goto(refName) {
  //   alert(refName);
     var element=document.getElementById(refName);
     element.scrollIntoView({  behavior: 'smooth', block: 'start', inline: 'start'  });

   }
  }
}
</script>
<style scoped="true">
.custom-row {
  margin-right: 0;
  margin-left: 0;
  height:50px;
}

.btn-block{
  height:100%;
  width:100% !important;
  text-align: left;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  border:none;
  border-bottom:1px solid;

}


.btn-color{
  color: #616161    ;
  background-color: #ffff;
  border-color: #e0e0e0 ;
  transition:0.3s;

 }
.btn-color:hover
{
  color: #ffff;
  background-color: #0277bd       ;
  border-color: #0277bd       ;
}
.btn-color-active
{
  color: #ffff;
  background-color: #0288d1     ;
  border-color: #0288d1     ;
  box-shadow: none;
}

.side-n{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
width:100%;

}
.container,.col
{
  padding-left:0;
  padding-right: 0;
}
@media (max-width: 768px) {
  .dropDown60px{
    margin-right: 60px;
  }
  }
</style>
